// extracted by mini-css-extract-plugin
export default {"ButtonPrimary":"Button-Login_ButtonPrimary__adDnW","pds-button":"Button-Login_pds-button__vM9vA","pds-button-primary":"Button-Login_pds-button-primary__Wywpo"};